import {combineReducers} from 'redux'
import {indexingReducer} from '../indexing/store/indexing.reducer'
import {RootAction, RootState} from './types'

const rootReducer = combineReducers<RootState, RootAction>({
  indexing: indexingReducer,
})

export default rootReducer
